import { Dialog, DialogContentHeadless } from 'v5/design-system/Dialog';
import { MountElementProps } from 'v5/messages/mount-element';
import {
  DownloadReportDialogContent,
  type DownloadReportDialogContentProps
} from './DownloadReportDialogContent';

export type DownloadReportDialogProps = MountElementProps &
  Omit<DownloadReportDialogContentProps, 'open'>;

export function DownloadReportDialog({
  open,
  onOpenChange,
  ...contentProps
}: DownloadReportDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContentHeadless className="max-w-120">
        <DownloadReportDialogContent open={open} {...contentProps} />
      </DialogContentHeadless>
    </Dialog>
  );
}
